import React from "react"
import { useNavigate } from "react-router-dom"
import {
  BarContainer,
  CampaignName
} from "./CampaignBar.styled"

export interface CampaignData {
  campaignId: string
  campaignName: string
  startDate: string
  endDate: string
  isPreview: boolean
}

interface CampaignBarProps {
  color: string
  width: string
  start: string
  campaignId: string
  campaignName: string
  startDate: string
  endDate: string
  showName: boolean
  isPreview?: boolean
  onHoverStart: (data: CampaignData) => void
  onHoverEnd: () => void
}

const CampaignBar: React.FC<CampaignBarProps> = ({
  color,
  width,
  start,
  campaignId,
  campaignName,
  startDate,
  endDate,
  showName,
  isPreview = false,
  onHoverStart,
  onHoverEnd
}) => {
  const widthPercent = parseFloat(width)
  const shouldShowName = showName && widthPercent > 10
  const navigate = useNavigate()

  return (
    <BarContainer
      onClick={() => !isPreview && navigate(`/campaigns/campaign/${campaignId}`)}
      onMouseEnter={() => onHoverStart({ campaignId, campaignName, startDate, endDate, isPreview })}
      onMouseLeave={onHoverEnd}
      $color={color}
      $width={width}
      $start={start}
      $isPreview={isPreview}
      data-tooltip-id="campaign-timeline-tooltip"
    >
      {shouldShowName && <CampaignName>{campaignName}</CampaignName>}
    </BarContainer>
  )
}

export default CampaignBar
